import React from "react";

function IOSSpinner() {
  return (
    <div className="flex space-x-2 items-center">
      <div className="h-2.5 w-2.5 bg-gray-400 rounded-full animate-pulse"></div>
      <div
        className="h-2.5 w-2.5 bg-gray-400 rounded-full animate-pulse"
        style={{ animationDelay: "0.2s" }}
      ></div>
      <div
        className="h-2.5 w-2.5 bg-gray-400 rounded-full animate-pulse"
        style={{ animationDelay: "0.4s" }}
      ></div>
    </div>
  );
}

export default IOSSpinner;
